import type {
  ExtendedConstraints,
  CapabilityConfig,
  EventHandlerCb,
} from '../../types';
import { hasOnlyKeysFromSet, hasValue } from '../../utils';

export const id = 'feature-flag';

export enum Events {
  GetResponse = 'feature-flag:get-response',
}

export enum Actions {
  Get = 'feature-flag:get',
}

export type Config = CapabilityConfig & {
  type: typeof id;
  features: string[];
};

export type GetResponsePayload = {
  feature: string;
  value: unknown;
};

export type GetPayload = {
  feature: string;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
  eventPayloadTuple: [Events.GetResponse, GetResponsePayload];
  eventHandlerTuple: [Events.GetResponse, EventHandlerCb<GetResponsePayload>];
  actionPayloadTuple: [Actions.Get, GetPayload];
}>;

const VALID_CONFIG_KEYS = ['type', 'features'] as const;
export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!hasOnlyKeysFromSet(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  const isFeaturesNotValid =
    hasValue(config, 'features') &&
    (!Array.isArray(config.features) ||
      !config.features.every((f) => typeof f === 'string'));

  if (isFeaturesNotValid) {
    return false;
  }

  return true;
}
